// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__5AySI","tipWrap":"List_tipWrap__GCVmw","tipIcon":"List_tipIcon__crNd7","text_error_color":"List_text_error_color__sfTt6"};